import styled from 'styled-components';
import { Icon as Icon$1 } from '../../icons/Icon.js';

const Icon = styled(Icon$1) `
  margin-top: 8px;
`;

export { Icon };
//# sourceMappingURL=styled.js.map
